import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const getPatientsBySiteService = async (access_token, siteId) => {
  try {
    return axios.get(`${api}/Correction/GetPatientsBySite?SiteId=${siteId}`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    throw err;
  }
};

export const getCorrectionGridDataService = async (
  page,
  pageSize,
  debouncedSearch,
  access_token,
  correctionCode,
  userId,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/Correction/GetCorrectionGridData?correctionCode=${correctionCode}&UserId=${userId}&CurrentSiteUserCultureCode=${cultureCode}&pageNumber=${page}&pageSize=${pageSize}&filter=${debouncedSearch}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    throw err;
  }
};

export const getDataCorrectionDetailsService = async (
  id,
  access_token,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/CorrectionWorkflow/CompletedWorkflowOnload?CorrectionId=${id}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    throw err;
  }
};

export const getDataOnLoadForDataCorrectionService = async (
  access_token,
  workflowId,
  cultureCode,
  userId,
) => {
  try {
    return axios.get(
      `${api}/CorrectionWorkflow/WorkflowOnload?workflowId=${workflowId}&userid=${userId}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    throw err;
  }
};

export const saveApprovalRejectionDataService = async (
  access_token,
  needsMoreInformation,
  workflowId,
  correctionId,
  userId,
  correctionActionId,
  discussionComment,
  cultureCode,
  payload,
) => {
  try {
    return axios.post(
      `${api}/CorrectionWorkflow/PostWorkflow?NeedsMoreInformation=${needsMoreInformation}&correctionId=${correctionId}&workflowId=${workflowId}&userid=${userId}&correctionActionId=${correctionActionId}&discussionComment=${discussionComment}&CurrentSiteUserCultureCode=${cultureCode}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    throw err;
  }
};
